/**
 * Not Found Page (404)
 *
 * Displayed when a route doesn't exist.
 */

import { Link } from 'react-router-dom';
import { routes } from '@presentation/router';
import { Button } from '@presentation/components/common';
import styles from './NotFoundPage.module.css';

export function NotFoundPage() {
  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <h1 className={styles.title}>404</h1>
        <h2 className={styles.subtitle}>Pagina no encontrada</h2>
        <p className={styles.description}>La pagina que buscas no existe o cambio de direccion.</p>
        <Link to={routes.home}>
          <Button size="large">Volver al inicio</Button>
        </Link>
      </div>
    </div>
  );
}
